export default {
    // 中
    zhCN: {
        activityNumber: '活动编号',
        activityName: '活动名称',
        activityStatus: '活动状态',
        activityDate: '选择活动日期',
        startDate: '活动开始日期',
        endDate: '活动结束日期',
        remarks: '备注',
        activity_details: '活动详情',
        activity_addition: '活动新增',
        confirm_enable: '确认启用',
        confirm_outage: '确认停用',
    },
    // 英
    enUS: {
        activityNumber: 'Campaign code',
        activityName: 'Campaign name',
        activityStatus: 'Status',
        activityDate: 'Activity date',
        startDate: 'Start date',
        endDate: 'End date',
        remarks: 'Remarks',
        activity_details: 'Activity details',
        activity_addition: 'Activity Addition',
        confirm_enable: 'Confirm enable',
        confirm_outage: 'Confirm outage',
    },
    // 德
    deDE: {
        activityNumber: 'Kampagnencode',
        activityName: 'Kampagnenname',
        activityStatus: 'Status',
        activityDate: 'Aktivitätsdatum',
        startDate: 'Startdatum',
        endDate: 'Enddatum',
        remarks: 'Bemerkungen',
        activity_details: 'Aktivitätsdetails',
        activity_addition: 'Aktivitätszusatz',
        confirm_enable: 'Bestätigung aktivieren',
        confirm_outage: 'Bestätigung der Störung',
    },
    // 法
    frFR: {
        activityNumber: 'Code de campagne',
        activityName: 'Nom de campagne',
        activityStatus: 'Statut',
        activityDate: 'Date d\'activité',
        startDate: 'Date de début',
        endDate: 'Date de fin',
        remarks: 'Remarque',
        activity_details: 'Détails de l\'activité',
        activity_addition: 'Ajout d\'activité',
        confirm_enable: 'Confirmer l\'activation',
        confirm_outage: 'Confirmer la panne',
    },
    // 意大利
    itIT: {
        activityNumber: 'Codice campagna',
        activityName: 'Nome della campagna',
        activityStatus: 'Stato',
        activityDate: 'Data di attività',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        remarks: 'Osservazioni',
        activity_details: 'Dettagli dell\'attività',
        activity_addition: 'Aggiunta di attività',
        confirm_enable: 'Conferma abilitazione',
        confirm_outage: 'Conferma interruzione',
    },
    // 荷兰
    nlNL: {
        activityNumber: 'Campagnecode',
        activityName: 'Campagnenaam',
        activityStatus: 'Status',
        activityDate: 'Activiteitsdatum',
        startDate: 'Startdatum',
        endDate: 'Einddatum',
        remarks: 'Opmerkingen',
        activity_details: 'Activiteitsdetails',
        activity_addition: 'Activiteit toevoeging',
        confirm_enable: 'Bevestig inschakelen',
        confirm_outage: 'Bevestig uitschakelen',
    },
    // 越南
    viVN: {
        activityNumber: 'Mã chiến dịch',
        activityName: 'Tên chiến dịch',
        activityStatus: 'Trạng thái',
        activityDate: 'Chọn ngày hoạt động',
        startDate: 'Ngày bắt đầu',
        endDate: 'Ngày kết thúc',
        remarks: 'Ghi chú',
        activity_details: 'Chi tiết hoạt động',
        activity_addition: 'Thêm hoạt động',
        confirm_enable: 'Xác nhận sử dụng',
        confirm_outage: 'Xác nhận tắt',
    },
    // 西班牙
    esES: {
        activityNumber: 'Número de actividad',
        activityName: 'Nombre de la actividad',
        activityStatus: 'Estado de la actividad',
        activityDate: 'Seleccione la fecha de la actividad',
        startDate: 'Fecha de inicio de la actividad',
        endDate: 'Fecha de finalización de la actividad',
        remarks: 'Observaciones',
        activity_details: 'Detalles de la actividad',
        activity_addition: 'Agregar actividad',
        confirm_enable: 'Confirmar habilitación',
        confirm_outage: 'Confirmar deshabilitación',
    },
    // 葡萄牙
    ptBR: {
        activityNumber: 'Número da atividade',
        activityName: 'Nome da atividade',
        activityStatus: 'Status da atividade',
        activityDate: 'Selecione a data da atividade',
        startDate: 'Data de início da atividade',
        endDate: 'Data de término da atividade',
        remarks: 'Observações',
        activity_details: 'Detalhes da atividade',
        activity_addition: 'Adição de atividade',
        confirm_enable: 'Confirmar habilitação',
        confirm_outage: 'Confirmar desativação',
    },
    // 波兰
    plPL: {
        activityNumber: 'Kod kampanii',
        activityName: 'Nazwa kampanii',
        activityStatus: 'Status kampanii',
        activityDate: 'Wybierz datę',
        startDate: 'Data rozpoczęcia',
        endDate: 'Data zakończenia',
        remarks: 'Uwagi',
        activity_details: 'Szczegóły wydarzenia',
        activity_addition: 'Dodatek do wydarzenia',
        confirm_enable: 'Potwierdź uruchomienie',
        confirm_outage: 'Potwierdź zatrzymanie',
    },
    // 土耳其
    trTR: {
        activityNumber: 'Kampanya kodu',
        activityName: 'Kampanya adı',
        activityStatus: 'Durum',
        activityDate: 'Etkinlik Zamanı',
        startDate: 'Başlangıç tarihi',
        endDate: 'Bitiş tarihi',
        remarks: 'Yorumlar',
        activity_details: 'Etkinlik detayları',
        activity_addition: 'Etkinlik Eklentisi',
        confirm_enable: 'Etkinleştirmeyi doğrula',
        confirm_outage: 'Devredışı bırakmayı onaylayın',
    },
    // 捷克语
    csCZ: {
        activityNumber: 'Kód kampaně',
        activityName: 'Název kampaně',
        activityStatus: 'Status',
        activityDate: 'Datum činnosti',
        startDate: 'Datum zahájení',
        endDate: 'Datum ukončení',
        remarks: 'Poznámky',
        activity_details: 'Podrobnosti o aktivitě',
        activity_addition: 'Přidání činnosti',
        confirm_enable: 'Potvrdit povolení',
        confirm_outage: 'Potvrzení výpadku',
    },
    // 匈牙利语翻译
    huHU: {
        activityNumber: 'Kampánykód',
        activityName: 'Kampánynév',
        activityStatus: 'Állapot',
        activityDate: 'Tevékenység dátuma',
        startDate: 'Kezdő dátum',
        endDate: 'Befejező dátum',
        remarks: 'Megjegyzések',
        activity_details: 'Tevékenység részletei',
        activity_addition: 'Tevékenység hozzáadása',
        confirm_enable: 'Engedélyezés megerősítése',
        confirm_outage: 'Hiány megerősítése',
    },
    // 俄罗斯语
    ruRU: {
        activityNumber: 'Код кампании',
        activityName: 'Название кампании',
        activityStatus: 'Статус',
        activityDate: 'Дата активности',
        startDate: 'Дата начала',
        endDate: 'Дата окончания',
        remarks: 'Примечания',
        activity_details: 'Детали активности',
        activity_addition: 'Добавление активности',
        confirm_enable: 'Подтвердить включение',
        confirm_outage: 'Подтвердить отключение',
    },
    // 沙特阿拉伯
    arSA: {
        activityNumber: 'رقم النشاط',
        activityName: 'اسم النشاط',
        activityStatus: 'حالة النشاط',
        activityDate: 'اختيار تاريخ النشاط',
        startDate: 'تاريخ بدء النشاط',
        endDate: 'تاريخ انتهاء النشاط',
        remarks: 'ملاحظات',
        activity_details: 'تفاصيل النشاط',
        activity_addition: 'إضافة نشاط',
        confirm_enable: 'تأكيد التمكين',
        confirm_outage: 'تأكيد الإيقاف',
    },
    // 保加利亚
    bgBG: {
        activityNumber: 'Номер на активността',
        activityName: 'Име на активността',
        activityStatus: 'Статус на активността',
        activityDate: 'Изберете дата на активността',
        startDate: 'Начална дата на активността',
        endDate: 'Крайна дата на активността',
        remarks: 'Забележки',
        activity_details: 'Детайли за активността',
        activity_addition: 'Добавяне на активност',
        confirm_enable: 'Потвърдете активирането',
        confirm_outage: 'Потвърдете деактивирането',
    },
    // 丹麦语
    daDK: {
        activityNumber: 'Aktivitetsnummer',
        activityName: 'Aktivitetsnavn',
        activityStatus: 'Aktivitetsstatus',
        activityDate: 'Vælg aktivitetsdato',
        startDate: 'Aktivitetens startdato',
        endDate: 'Aktivitetens slutdato',
        remarks: 'Bemærkninger',
        activity_details: 'Aktivitetsdetaljer',
        activity_addition: 'Tilføj aktivitet',
        confirm_enable: 'Bekræft aktivering',
        confirm_outage: 'Bekræft deaktivering',
    },
    // 芬兰语
    fiFI: {
        activityNumber: 'Toiminnan numero',
        activityName: 'Toiminnan nimi',
        activityStatus: 'Toiminnan tila',
        activityDate: 'Valitse toimintapäivä',
        startDate: 'Toiminnan aloituspäivämäärä',
        endDate: 'Toiminnan päättymispäivämäärä',
        remarks: 'Huomautukset',
        activity_details: 'Toiminnan tiedot',
        activity_addition: 'Lisää toiminta',
        confirm_enable: 'Vahvista käyttöönotto',
        confirm_outage: 'Vahvista poistaminen käytöstä',
    },
    // 繁体中文台湾
    zhTW: {
        activityNumber: '活動編號',
        activityName: '活動名稱',
        activityStatus: '活動狀態',
        activityDate: '選擇活動日期',
        startDate: '活動開始日期',
        endDate: '活動結束日期',
        remarks: '備註',
        activity_details: '活動詳情',
        activity_addition: '新增活動',
        confirm_enable: '確認啟用',
        confirm_outage: '確認停用',
    },
    // 克罗地亚
    hrHR: {
        activityNumber: 'Broj aktivnosti',
        activityName: 'Naziv aktivnosti',
        activityStatus: 'Status aktivnosti',
        activityDate: 'Odaberite datum aktivnosti',
        startDate: 'Datum početka aktivnosti',
        endDate: 'Datum završetka aktivnosti',
        remarks: 'Napomene',
        activity_details: 'Detalji aktivnosti',
        activity_addition: 'Dodavanje aktivnosti',
        confirm_enable: 'Potvrdi omogućavanje',
        confirm_outage: 'Potvrdi onemogućavanje',
    },
    // 拉脱维亚
    lvLV: {
        activityNumber: 'Darbības numurs',
        activityName: 'Darbības nosaukums',
        activityStatus: 'Darbības statuss',
        activityDate: 'Izvēlieties darbības datumu',
        startDate: 'Darbības sākuma datums',
        endDate: 'Darbības beigu datums',
        remarks: 'Piezīmes',
        activity_details: 'Darbības informācija',
        activity_addition: 'Pievienot darbību',
        confirm_enable: 'Apstiprināt iespējošanu',
        confirm_outage: 'Apstiprināt atspējošanu',
    },
    // 立陶宛
    ltLT: {
        activityNumber: 'Veiklos numeris',
        activityName: 'Veiklos pavadinimas',
        activityStatus: 'Veiklos būsena',
        activityDate: 'Pasirinkite veiklos datą',
        startDate: 'Veiklos pradžios data',
        endDate: 'Veiklos pabaigos data',
        remarks: 'Pastabos',
        activity_details: 'Veiklos informacija',
        activity_addition: 'Pridėti veiklą',
        confirm_enable: 'Patvirtinti įjungimą',
        confirm_outage: 'Patvirtinti išjungimą',
    },
    // 罗马尼亚
    roRO: {
        activityNumber: 'Numărul activității',
        activityName: 'Numele activității',
        activityStatus: 'Starea activității',
        activityDate: 'Selectați data activității',
        startDate: 'Data începerii activității',
        endDate: 'Data încheierii activității',
        remarks: 'Observații',
        activity_details: 'Detaliile activității',
        activity_addition: 'Adăugare activitate',
        confirm_enable: 'Confirmă activarea',
        confirm_outage: 'Confirmă dezactivarea',
    },
    // 挪威博克马尔
    nbNO: {
        activityNumber: 'Aktivitetsnummer',
        activityName: 'Aktivitetsnavn',
        activityStatus: 'Aktivitetsstatus',
        activityDate: 'Velg aktivitetsdato',
        startDate: 'Startdato for aktivitet',
        endDate: 'Sluttdato for aktivitet',
        remarks: 'Merknader',
        activity_details: 'Aktivitetsdetaljer',
        activity_addition: 'Legg til aktivitet',
        confirm_enable: 'Bekreft aktivering',
        confirm_outage: 'Bekreft deaktivering',
    },
    // 葡萄牙语巴西
    ptBX: {
        activityNumber: 'Número da atividade',
        activityName: 'Nome da atividade',
        activityStatus: 'Status da atividade',
        activityDate: 'Selecione a data da atividade',
        startDate: 'Data de início da atividade',
        endDate: 'Data de término da atividade',
        remarks: 'Observações',
        activity_details: 'Detalhes da atividade',
        activity_addition: 'Adicionar atividade',
        confirm_enable: 'Confirmar ativação',
        confirm_outage: 'Confirmar desativação',
    },
    // 瑞典语
    svSE: {
        activityNumber: 'Aktivitetsnummer',
        activityName: 'Aktivitetsnamn',
        activityStatus: 'Aktivitetsstatus',
        activityDate: 'Välj aktivitetsdatum',
        startDate: 'Aktivitetens startdatum',
        endDate: 'Aktivitetens slutdatum',
        remarks: 'Anmärkningar',
        activity_details: 'Aktivitetsinformation',
        activity_addition: 'Lägg till aktivitet',
        confirm_enable: 'Bekräfta aktivering',
        confirm_outage: 'Bekräfta inaktivering',
    },
    // 斯洛伐克
    skSK: {
        activityNumber: 'Číslo aktivity',
        activityName: 'Názov aktivity',
        activityStatus: 'Stav aktivity',
        activityDate: 'Vyberte dátum aktivity',
        startDate: 'Dátum začiatku aktivity',
        endDate: 'Dátum ukončenia aktivity',
        remarks: 'Poznámky',
        activity_details: 'Podrobnosti aktivity',
        activity_addition: 'Pridanie aktivity',
        confirm_enable: 'Potvrďte povolenie',
        confirm_outage: 'Potvrďte zakázanie',
    },
    // 斯洛文尼亚
    slSI: {
        activityNumber: 'Številka dejavnosti',
        activityName: 'Ime dejavnosti',
        activityStatus: 'Stanje dejavnosti',
        activityDate: 'Izberite datum dejavnosti',
        startDate: 'Začetni datum dejavnosti',
        endDate: 'Končni datum dejavnosti',
        remarks: 'Opombe',
        activity_details: 'Podrobnosti dejavnosti',
        activity_addition: 'Dodajanje dejavnosti',
        confirm_enable: 'Potrdite omogočanje',
        confirm_outage: 'Potrdite onemogočanje',
    },
    // 泰语
    thTH: {
        activityNumber: 'หมายเลขกิจกรรม',
        activityName: 'ชื่อกิจกรรม',
        activityStatus: 'สถานะกิจกรรม',
        activityDate: 'เลือกวันที่กิจกรรม',
        startDate: 'วันที่เริ่มกิจกรรม',
        endDate: 'วันที่สิ้นสุดกิจกรรม',
        remarks: 'หมายเหตุ',
        activity_details: 'รายละเอียดกิจกรรม',
        activity_addition: 'เพิ่มกิจกรรม',
        confirm_enable: 'ยืนยันการเปิดใช้งาน',
        confirm_outage: 'ยืนยันการปิดใช้งาน',
    },
    // 乌克兰语
    ukUA: {
        activityNumber: 'Номер активності',
        activityName: 'Назва активності',
        activityStatus: 'Статус активності',
        activityDate: 'Виберіть дату активності',
        startDate: 'Дата початку активності',
        endDate: 'Дата завершення активності',
        remarks: 'Примітки',
        activity_details: 'Деталі активності',
        activity_addition: 'Додавання активності',
        confirm_enable: 'Підтвердити активацію',
        confirm_outage: 'Підтвердити деактивацію',
    },
    // 希腊语
    elGR: {
        activityNumber: 'Αριθμός δραστηριότητας',
        activityName: 'Όνομα δραστηριότητας',
        activityStatus: 'Κατάσταση δραστηριότητας',
        activityDate: 'Επιλογή ημερομηνίας δραστηριότητας',
        startDate: 'Ημερομηνία έναρξης δραστηριότητας',
        endDate: 'Ημερομηνία λήξης δραστηριότητας',
        remarks: 'Σχόλια',
        activity_details: 'Λεπτομέρειες δραστηριότητας',
        activity_addition: 'Προσθήκη δραστηριότητας',
        confirm_enable: 'Επιβεβαίωση ενεργοποίησης',
        confirm_outage: 'Επιβεβαίωση απενεργοποίησης',
    },
    // 爱沙尼亚
    etEE: {
        activityNumber: 'Tegevuse number',
        activityName: 'Tegevuse nimi',
        activityStatus: 'Tegevuse olek',
        activityDate: 'Valige tegevuse kuupäev',
        startDate: 'Tegevuse alguskuupäev',
        endDate: 'Tegevuse lõppkuupäev',
        remarks: 'Märkused',
        activity_details: 'Tegevuse üksikasjad',
        activity_addition: 'Lisa tegevus',
        confirm_enable: 'Kinnita lubamine',
        confirm_outage: 'Kinnita keelamine',
    },
    // 哈萨克
    kkKZ: {
        activityNumber: 'Әрекет нөмірі',
        activityName: 'Әрекет атауы',
        activityStatus: 'Әрекет күйі',
        activityDate: 'Әрекет күнін таңдаңыз',
        startDate: 'Әрекеттің басталу күні',
        endDate: 'Әрекеттің аяқталу күні',
        remarks: 'Ескертпелер',
        activity_details: 'Әрекет туралы мәліметтер',
        activity_addition: 'Әрекет қосу',
        confirm_enable: 'Қосуды растау',
        confirm_outage: 'Сөндіруді растау',
    },
    // 希伯来语
    heIL: {
        activityNumber: 'מספר פעילות',
        activityName: 'שם הפעילות',
        activityStatus: 'סטטוס הפעילות',
        activityDate: 'בחר תאריך פעילות',
        startDate: 'תאריך תחילת הפעילות',
        endDate: 'תאריך סיום הפעילות',
        remarks: 'הערות',
        activity_details: 'פרטי הפעילות',
        activity_addition: 'הוספת פעילות',
        confirm_enable: 'אשר הפעלה',
        confirm_outage: 'אשר השבתה',
    },
};
